import {Component, forwardRef, Input, OnDestroy, OnInit} from '@angular/core';
import {SearchMenuOptions} from "../../../../domain/search-filter.interface";
import {ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR} from "@angular/forms";
import {debounceTime, distinctUntilChanged, Subject, takeUntil, throttleTime} from "rxjs";

@Component({
  selector: 'app-search-filter',
  templateUrl: './search-filter.component.html',
  styleUrls: ['./search-filter.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SearchFilterComponent),
      multi: true,
    },
  ],
})
export class SearchFilterComponent implements OnInit, OnDestroy, ControlValueAccessor {
  @Input() menuOptions: SearchMenuOptions[] = [];
  @Input() placeholder: string = "Search..."

  destroy$ = new Subject<void>()

  form!: FormGroup;

  showMenu: boolean = false;
  menuCoords = {
    x: 0,
    y: 0
  }

  private _value: {[key: string]: string} | null = null

  set value(val: {[key: string]: string} | null) {
    this._value = val;
    this.onChange(this._value);
    this.onTouch(this._value);
  }

  get value() {
    return this._value;
  }

  get_value(){
    return {
      label: this.menuOptions.filter((val) => val.value === Object.entries(this._value as object)[0][0])[0].label,
      value: Object.entries(this._value as object)[0][1],
    }
  }

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      search: ""
    })

    this.search?.valueChanges.pipe(
      takeUntil(this.destroy$),
      distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
      debounceTime(400),
      throttleTime(400)
    ).subscribe((value) => {
      if (!this.menuOptions.length) {
        this.value = {
          search: value
        };
      }
    })
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onChange: any = () => {};
  onTouch: any = () => {};

  registerOnChange(fn: any): void {
    this.onChange = fn
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn
  }

  writeValue(value: {[key: string]: string}): void {
    // console.log("Widget write value", obj)
    this._value = value
  }

  toggleMenu(event: any) {
    this.menuCoords = {
      x: event.target.getBoundingClientRect().left,
      y: event.target.getBoundingClientRect().top
    }
    this.showMenu = !this.showMenu;
  }

  selectMenuOption(option: SearchMenuOptions){
    if (this.search?.value){
      this.value = {
        [option.value]: this.search?.value
      }
      this.search.patchValue("");
    }
  }

  clean_value(){
    this.value = null;
  }

  get search(){
    return this.form.get("search")
  }



}
